var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "64px",
    width: "64px",
    id: "Filled_Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-6 -6 36.00 36.00",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trash-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,4V0H8v4H1v2h3v17h16V6h3V4H16z M10,18H8v-8h2V18z M16,18h-2v-8h2V18z M10,2h4v2h-4V2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/trash-filled.b8e238bb9f3b097ec4ed858d0f7a77a0.svg";
export { ForwardRef as ReactComponent };